import React, {Component} from 'react';
import {NavBar, List, DatePicker,Picker, Toast,} from 'antd-mobile';
import {lineList,driverList,carList,batchDelete} from "../../../service/shiftService";
import moment from 'moment';
import './style.less';
import {connect} from "react-redux";

const now = new Date();

@connect(
    state => ({userInfo: state.userInfo}),
)
export default class BatchDeleteClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
          lineData:[],
          lineClass:"",
          lineId:"",//用于请求价格模板和运行时间模板的数据
          startDate:"",
          endDate:"",
        };

        this.noData = this.noData.bind(this);
    }
    componentDidMount() {
      this.getLineData();
      // this.getDriverData();
    }
    //获取起止区域数据
    getLineData(){
      let params = {
          token: this.props.userInfo.token,
          "data": {
              "dispatcherId": this.props.userInfo.userId
          }
      };
      lineList(params).then((res) => {
        if (res.data.code === '0000') {
            let lineData = []
            let data = res.data.data
            for(let i in data){
                let temp = data[i];
                lineData.push({
                label:temp.name,
                value:temp.name,
                id:temp.id
                })
            }
            this.setState({
                lineData:lineData
            })
        }
        else if (res.data.code === '1401') {
            document.location = `js://toLogin?token=${this.props.userInfo.token}`;
        }
        else {
            Toast.info(res.data.msg);
        }
      })
    };
    //获取司机数据
    getDriverData(){
      let params = {
          token: this.props.userInfo.token,
          "data": {
              "dispatcherId": this.props.userInfo.userId,
              "businessType":1,
          }
      };
      driverList(params).then((res) => {
            if (res.data.code === '0000') {
                let driverData = []
                let data = res.data.data
                for(let i in data){
                    let temp = data[i];
                    driverData.push({
                    label:temp.name,
                    value:temp.name,
                    id:temp.id
                    })
                }
                this.setState({
                    driverData:driverData
                })
            }
            else if (res.data.code === '1401') {
                document.location = `js://toLogin?token=${this.props.userInfo.token}`;
            }
            else {
                Toast.info(res.data.msg);
            }
        })
    };
    //获取车辆数据
    getCarData(){
        let params = {
            token: this.props.userInfo.token,
            "data":{
            "driverId":this.state.driverId,
            "businessType":"1",
            "dispatcherId": this.props.userInfo.userId,
        }
        };
        carList(params).then((res) => {
            if (res.data.code === '0000') {
              let carData = []
              let data = res.data.data
              for(let i in data){
                  let temp = data[i];
                  carData.push({
                  label:temp.carNum,
                  value:temp.carNum,
                  id:temp.id,
                  seatNum:temp.seatNum
                  })
              }
              this.setState({
                  carNumData:carData
              })
            }
            else if (res.data.code === '1401') {
              document.location = `js://toLogin?token=${this.props.userInfo.token}`;
            }
            else {
              Toast.info(res.data.msg);
            }
        })
    };
    addActive(v, key){
        if(key == 'lineClass'){
            let datas = this.state.lineData;
            let labels = [];
            datas.forEach(e =>{
              labels.push(e.label)
            })
            this.setState({
                [key]:v,
                lineId:datas[labels.indexOf(v[0])].id,
                lineDriver:"",
                lineCar:"",
                runTime:"",
                priceModel:"",
            });
          };
        if(key == 'lineDriver'){
          let datas = this.state.driverData;
          let labels = [];
          datas.forEach(e =>{
            labels.push(e.label)
          })
          this.setState({
                  [key]:v,
                  driverId:datas[labels.indexOf(v[0])].id
          });
          setTimeout(() => {
            this.getCarData();
          }, 1000);
        
        };
        if(key == 'lineCar'){
          let datas = this.state.carNumData;
          let labels = [];
          datas.forEach(e =>{
            labels.push(e.label)
          })
          this.setState({
            [key]:v,
            carId:datas[labels.indexOf(v[0])].id,
            seatNum:datas[labels.indexOf(v[0])].seatNum,
            carModal:false
          });
        }
        if(key == 'priceModel'){
          let datas = this.state.priceData;
          let labels = [];
          datas.forEach(e =>{
            labels.push(e.label)
          })
          this.setState({
            [key]:v,
            priceTemplateId:datas[labels.indexOf(v[0])].id,
            priceModal:false,
          });
        }
        if(key == 'runTime'){
          let datas = this.state.runTimeData;
          let labels = [];
          datas.forEach(e =>{
            labels.push(e.label)
          })
          this.setState({
            [key]:v,
            runTimeTemplateId:datas[labels.indexOf(v[0])].id,
            runTimeModal:false
          });
        }
        if(key == "startDate" || key == 'endDate'){
          this.setState({
            [key]:v,
          });
        }
    }
  
    // 新增运力
    ok = () => {
      if(!this.state.lineId){
        Toast.info("请选择起止区域")
        return
      }
      if(!this.state.startDate || !this.state.endDate){
        Toast.info("请选择开始或结束时间")
        return
      }
        let params = {
            token: this.props.userInfo.token,
            "data":{
                "lineId":this.state.lineId,
                "startDate":moment(this.state.startDate).format('YYYY-MM-DD HH:mm:ss'),
                "endDate":moment(this.state.endDate).format('YYYY-MM-DD HH:mm:ss'),
            }
        };
        console.log(params)
        Toast.loading("正在加载",0);
        batchDelete(params).then((res) => {
          if (res.data.code === '0000') {
              Toast.hide();
              Toast.info('批量删除行程成功');
              setTimeout(() => {
              this.props.history.goBack();
              }, 1000);
          } else {
              Toast.info(res.data.msg);
          }
        })
    };
    noData(k){
      //起止区域根据调度人员获取，司机也根据调度人员获取，车辆根据司机获取，价格模板根据车辆返回的出行位置数和起止区域，运行时间根据起止区域获取
      if(k == 'car'){
        if(this.state.lineDriver == ''){
          Toast.info('请先选择司机')
        }else{
          this.setState({
            carModal:true
          })
        }
      }   
      
    }
    render() {
        return (
            <div className="batchDeleteClass addShiftScreen">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()}></i>}
                >批量删除行程</NavBar>
                    <List className="address">
                      <Picker
                          cols={1}
                          extra={'请选择起止区域'}
                          data={this.state.lineData}
                          value={this.state.lineClass}
                          onOk={(v) =>this.addActive(v, 'lineClass')}
                      >
                          <List.Item arrow="horizontal">起止区域</List.Item>
                      </Picker>
                      <DatePicker
                          value={this.state.startDate}
                          extra={'请选择开始日期'}
                          onOk={(v) =>this.addActive(v, 'startDate')}
                          // defaultDate={new Date()}
                          minDate={new Date(+now - 31536000000)}
                          maxDate={new Date(+now + 5184000000)}
                          onChange={(v)=>this.setState({startDate:v})}
                      >
                          <List.Item arrow="horizontal">开始日期</List.Item>
                      </DatePicker>
                      <DatePicker
                          value={this.state.endDate}
                          extra={'请选择结束日期'}
                          onOk={(v) =>this.addActive(v, 'endDate')}
                          minDate={new Date(+now - 5184000000)}
                          maxDate={new Date(+now + 5184000000)}
                          onChange={(v)=>this.setState({endDate:v})}
                      >
                          <List.Item arrow="horizontal">结束日期</List.Item>
                      </DatePicker>
                </List> 
                <button className="addBtn" onClick={this.ok}>删除</button>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Home/BatchDeleteClass/index.js